import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import MobileHeader from '~/components/header/Mobile.vue';
import DefaultHeader from '~/components/header/Default.vue';
import NavBar from '@/components/navigation/NavBar.vue';
import SubHeader from '~/components/header/Sub.vue';
import DefaultFooter from '~/components/footer/Default.vue';
import Sidebar from "~/components/pages/adminDashboard/Sidebar.vue";

var TwoColumnAdminLayout = /*#__PURE__*/function (_Vue) {
  _inherits(TwoColumnAdminLayout, _Vue);

  var _super = _createSuper(TwoColumnAdminLayout);

  function TwoColumnAdminLayout() {
    _classCallCheck(this, TwoColumnAdminLayout);

    return _super.apply(this, arguments);
  }

  _createClass(TwoColumnAdminLayout, [{
    key: "created",
    value: function created() {
      window.addEventListener("resize", this.toggleMobileCss);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.toggleMobileCss();
    }
  }, {
    key: "toggleMobileCss",
    value: function toggleMobileCss() {
      if (window.innerWidth < 798) {
        document.getElementById('kt_wrapper').className = '';
      } else {
        document.getElementById('kt_wrapper').className = 'kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper';
      }
    }
  }]);

  return TwoColumnAdminLayout;
}(Vue);

TwoColumnAdminLayout = __decorate([Component({
  components: {
    MobileHeader: MobileHeader,
    DefaultHeader: DefaultHeader,
    NavBar: NavBar,
    SubHeader: SubHeader,
    DefaultFooter: DefaultFooter,
    Sidebar: Sidebar
  },
  head: function head() {
    return {
      bodyAttrs: {
        class: 'kt-page--loading-enabled kt-page--fixed kt-header--fixed kt-header--minimize-topbar kt-header-mobile--fixed kt-quick-panel--right kt-demo-panel--right kt-offcanvas-panel--right kt-subheader--enabled kt-subheader--transparent'
      }
    };
  }
})], TwoColumnAdminLayout);
export default TwoColumnAdminLayout;